import React, { useState } from "react";

const DividasEmAbertoContext = React.createContext({
});

const DividasEmAbertoProvider = (props) => {
  const [filtro, setFiltro] = useState({});
  const [running, setRunning] = useState(false);
  const [ready, setReady] = useState(false);

  return (
    <DividasEmAbertoContext.Provider value={{
      filtro: filtro,
      setFiltro: setFiltro,
      running: running,
      setRunning: setRunning,
      ready: ready,
      setReady: setReady
    }}>
      {props.children}
    </DividasEmAbertoContext.Provider>
  )
}

export { DividasEmAbertoProvider };
export default DividasEmAbertoContext;
